module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }